import React from 'react';

import classNames from 'classnames/bind';
import style from './Spreader.scss';
const ctx = classNames.bind(style);

const Spreader = props => (
  <div className={ctx('spreader')}>{props.children}</div>
);

export default Spreader;
